// @flow
import React, { Component, Fragment } from 'react';
import type { State } from 'store';
import { connect } from 'react-redux';
import EventComments from 'components/event/EventComments/EventComments';
import EventCommentInput from 'components/event/EventCommentInput/EventCommentInput';
import { EventsActions } from 'store/actionCreators';
import type { Comment, RemoveComment, SubCommentsMap } from 'store/modules/events';
import QuestionModal from 'components/common/QuestionModal';
import { type ContextRouter, withRouter } from 'react-router-dom';

type Props = {
  eventId: ?string,
  comments: ?(Comment[]),
  subCommentsMap: SubCommentsMap,
  shouldCancel: boolean,
  logged: boolean,
  loading: boolean,
  username: ?string,
  removeComment: RemoveComment,
  commentsCount: ?number,
} & ContextRouter;

class EventCommentsContainer extends Component<Props> {
  onOpenRemove = (payload: { commentId: string, parentId: ?string }) => {
    EventsActions.openCommentRemove(payload);
  };

  onCancelRemove = () => {
    EventsActions.cancelCommentRemove();
  };

  onConfirmRemove = () => {
    const { eventId, removeComment } = this.props;
    if (!eventId || !removeComment.commentId) return;
    EventsActions.removeComment({
      eventId,
      commentId: removeComment.commentId,
    });
  };

  onEditComment = ({
    commentId,
    parentId,
    text,
  }: {
    commentId: string,
    parentId: ?string,
    text: string,
  }) => {
    const { eventId } = this.props;
    if (!eventId) return Promise.resolve();
    return EventsActions.editComment({
      eventId,
      commentId,
      text,
      parentId,
    });
  };

  onWriteComment = async (text: string, replyTo: ?string, parentId?: ?string) => {
    const { eventId } = this.props;
    if (!eventId) return Promise.resolve();
    let comment = null;
    try {
      comment = await EventsActions.writeComment({
        eventId,
        text,
        replyTo,
      });
      if (replyTo) {
        await this.onReadReplies(replyTo, parentId);
      } else {
        await EventsActions.readComments({ eventId });
      }
    } catch (e) {
      console.log(e);
    }
    return comment;
  };

  initialize = async () => {
    const { eventId, shouldCancel } = this.props;
    if (!eventId) return;
    try {
      if (shouldCancel) return;
      await EventsActions.readComments({ eventId });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.eventId !== this.props.eventId) {
      this.initialize();
    }
  }

  onReadReplies = (commentId: string, parentId?: ?string) => {
    const { eventId } = this.props;
    if (!eventId) return Promise.resolve(null);
    return EventsActions.readSubComments({
      eventId,
      commentId,
      parentId,
    });
  };

  render() {
    const {
      comments,
      subCommentsMap,
      logged,
      loading,
      username,
      removeComment,
      commentsCount,
    } = this.props;

    if (loading) return null;

    return (
      <Fragment>
        <EventComments
          logged={logged}
          commentInput={logged && <EventCommentInput onWriteComment={this.onWriteComment} />}
          comments={comments}
          subCommentsMap={subCommentsMap}
          onReply={this.onWriteComment}
          onReadReplies={this.onReadReplies}
          username={username}
          onOpenRemove={this.onOpenRemove}
          onEditComment={this.onEditComment}
          commentsCount={commentsCount || 0}
          currentPath={this.props.location.pathname}
        />
        <QuestionModal
          title="이벤트 댓글 삭제"
          description="이 이벤트 댓글을 정말로 삭제하시겠습니까?"
          confirmText="삭제하기"
          onConfirm={this.onConfirmRemove}
          onCancel={this.onCancelRemove}
          open={removeComment.visible}
        />
      </Fragment>
    );
  }
}

export default connect(
  (state: State) => ({
    logged: !!state.user.user,
    eventId: state.events.event && state.events.event.id,
    comments: state.events.comments,
    subCommentsMap: state.events.subCommentsMap,
    shouldCancel: state.common.ssr && !state.common.router.altered,
    loading: !state.events.event || state.pender.pending['events/READ_COMMENTS'],
    username: state.user.user && state.user.user.username,
    removeComment: state.events.removeComment,
    commentsCount: state.events.event && state.events.event.comments_count,
  }),
  () => ({}),
)(withRouter(EventCommentsContainer));



// WEBPACK FOOTER //
// ./src/containers/event/EventCommentsContainer.js